import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from '../../clients-module/services/client.service';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { UserService } from '../../users-module/services/user.service';
import { AuthService } from '../../services/auth.service';
import { PhonePipe } from '../../pipes/phone.pipe';
import { ClientLocation } from '../../clients-module/models/clientLocation';
import { PropertyService } from '../services/property.service';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { PaginationEventData } from 'src/app/shared-components-module/pagination-top/models/paginationEventData';
import { FilteringService } from 'src/app/services/filtering.service';
import { PropertyFilter } from '../models/propertyFilter';
import { FilteringIsActiveValues } from 'src/app/models/filtering';


@Component({
    selector: 'app-properties',
    templateUrl: './properties.component.html',
    styleUrls: ['./properties.component.less']
})
export class PropertiesComponent implements OnInit, AfterViewInit, OnDestroy {
    public displayFilters = true;
    public pageIncrements: any[] = ['10', '30', '50', '100', '200'];
    public pageIncrement = 30;
    public currentPage = 0;

    constructor(public phone: PhonePipe,
        public auth: AuthService,
        public users: UserService,
        public screening: ScreeningService,
        public clients: ClientService,
        public toast: ToastrService,
        public location: Router,
        public filtering : FilteringService,
        public propertySvc : PropertyService,
        public activatedRoute: ActivatedRoute) {
    }

    public ngOnInit(): void {
      this.propertySvc.propertyFilter.isActive = true;
    }

    public ngOnDestroy(): void {
      this.filtering.filters = [];
      this.propertySvc.properties = [];
      this.propertySvc.propertyFilter= new PropertyFilter();
    }

    applyFilters(): void {
      this.propertySvc.properties = [];
      this.propertySvc.FetchPropertyList(this.propertySvc.propertyFilter);
      this.currentPage = 0;
    }

    public get clientLocations() : Array<ClientLocation> {
        if(!this.propertySvc.properties) return [];
        return this.propertySvc.properties;
      }


    public viewProperty(prop: ClientLocation) {
        this.clients.activeClientLocation = prop;
        this.location.navigateByUrl(`properties/stats/${prop.id}/${prop.clientId}`);
    }

    public ngAfterViewInit(): void {
    }

    public showFilters(): void {
        this.displayFilters = !this.displayFilters;
    }

    public resetPageSize(pageSize: number): void {
        this.pageIncrement = pageSize;
    }

    public clearFilters(){
        this.filtering.filters = [];
        this.propertySvc.properties = [];
        this.propertySvc.propertyFilter = new PropertyFilter();
        this.propertySvc.FetchPropertyList(this.propertySvc.propertyFilter);
    }

    public onPaginationChanged(event : PaginationEventData) {
      this.propertySvc.properties = [];
      this.propertySvc.FetchPropertyList(this.propertySvc.propertyFilter);
      this.filtering.clearTransientFilters();
    }
}
